import React, {
    useEffect,
    useRef
} from "react";

import "./PilotFlame.css";
import { PlantStore } from "../engine/PlantStore";
import { usePlantStore } from "../engine/usePlantStore";


function PilotFlame({

  value = 0,

  spark = false,
  setSpark = () => {},

  x = 100,
  y = 100,

  width = 80,
  height = 140

}) {



/* ==============================
   PRESSURE VALUE
============================== */

const pilotPressure =
Number(value) || 0;



/* ==============================
   FLAME CONDITION
============================== */


const flameAvailable =
pilotPressure > 0.017;





/* ==============================
   RESET SPARK WHEN PRESSURE LOW
============================== */


const sparkResetRef = useRef(false);

useEffect(() => {

    if (!flameAvailable) {

        if (!sparkResetRef.current) {

            sparkResetRef.current = true;

            setSpark(false);

        }

    } else {

        sparkResetRef.current = false;

    }

}, [flameAvailable]);



/* =================================================
   SAVE MAIN FLAME STATUS
================================================= */

useEffect(() => {

    PlantStore.set({

        transmitters: {

            ...PlantStore.get().transmitters,

            Pilot_Flame_On: flameAvailable

        }

    });

}, [flameAvailable]);


/* ==============================
   FLAME INTENSITY
============================== */


/*

0.05 = minimum flame

0.114 = maximum flame

*/


const MIN_PRESSURE = 0.05;

const MAX_PRESSURE = 0.114;



const flameRatio =
Math.max(

0,

Math.min(

(
 pilotPressure - MIN_PRESSURE
)
/
(
 MAX_PRESSURE - MIN_PRESSURE
),

1

)

);





/* ==============================
   SCALE CONTROL
============================== */


/*

0.05
small flame


0.114
full flame

*/


const flameHeightScale =
0.35 +
(
 flameRatio * 0.65
);



const flameWidthScale =
0.45 +
(
 flameRatio * 0.55
);






const flameON =
spark &&
flameAvailable;





return (


<div


className="pilot-flame-container"


style={{


position:"absolute",

left:x,

top:y,

width,

height,

display:"flex",

alignItems:"center",

justifyContent:"center"


}}


>





<svg

width={width}

height={height}

viewBox="0 0 100 150"

>



<defs>


<radialGradient id="pilotGradient">


<stop

offset="0%"

stopColor="#ffffff"

/>



<stop

offset="45%"

stopColor="#ffff00"

/>



<stop

offset="100%"

stopColor="#ff3300"

/>



</radialGradient>



</defs>






{

flameON &&



<g


className="pilot-flame-outer"


style={{


transformOrigin:
"50px 150px",



transform:


`

scale(

${flameWidthScale},

${flameHeightScale}

)

`


}}


>




<path



d="

M50 150

C20 120 25 85 45 60

C40 35 65 15 60 0

C90 45 85 85 70 110

C65 130 65 145 50 150

Z

"


fill="url(#pilotGradient)"


/>




</g>


}



</svg>



</div>


);


}


export default PilotFlame;